export function isNumeric(value: any): value is number {
    return !isNaN(parseFloat(value)) && isFinite(Number(value));
}
